import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { DealBusinessTypeApiService } from '../services/deal-business-type-api.service';
import { DealBusinessTypeResponse } from '../models/deal-business-type.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-deal-business-type-list',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, PageBreadcrumbComponent, HasPermissionDirective],
  templateUrl: './deal-business-type-list.component.html',
})
export class DealBusinessTypeListComponent implements OnInit {
  items: DealBusinessTypeResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private api: DealBusinessTypeApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    const businessId = this.authService.getCurrentUser()?.businessId;
    if (!businessId) {
      this.error = 'No se pudo obtener el negocio del usuario';
      return;
    }

    this.loading = true;
    this.error = '';

    this.api.getAll(businessId).subscribe({
      next: (data) => {
        this.items = data.content;
        this.loading = false;
      },
      error: (err) => {
        this.error =
          err.error?.message || 'Error al cargar los tipos de negocio';
        this.loading = false;
        console.error('Error:', err);
      },
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-deals/tipos-negocio/crear']);
  }

  editar(item: DealBusinessTypeResponse): void {
    this.router.navigate(['/config-deals/tipos-negocio/editar', item.id]);
  }

  async eliminar(item: DealBusinessTypeResponse): Promise<void> {
    const businessId = this.authService.getCurrentUser()?.businessId;
    if (!businessId) return;

    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar tipo de negocio',
      message: `¿Está seguro de eliminar el tipo de negocio "${item.name}"?`,
    });
    if (!ok) return;
    this.api.delete(item.id, businessId).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Tipo de negocio', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.confirmDialog.alert({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar el tipo de negocio',
          variant: 'danger',
        });
        this.toast.error({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar el tipo de negocio',
        });
      },
    });
  }
}
